import { Subject } from 'rxjs';

const subject = new Subject();

export const SalvarPainelService = {
    sendSalvar: (msg: boolean) => subject.next(msg),
    getSalvar: () => subject.asObservable()
};